import React from "react";
import "react-pro-sidebar/dist/css/styles.css";
import { Menu, MenuItem, ProSidebar } from "react-pro-sidebar";
import { FaEnvelope, FaCogs, FaGlobe, FaHome } from "react-icons/fa";
import "./Sidebar.scss";
import ReactTooltip from "react-tooltip";

// Scroll and Styles
import styled from "styled-components";
import { animateScroll as scroll } from "react-scroll";
import { Link } from "react-router-dom";

//   ScrollHandlers
export const toggleHome = () => {
  scroll.scrollToTop();
};
export const toggleContact = () => {
  scroll.scrollToBottom();
};
export const toggleSkills = (pos) => {
  scroll.scrollTo(pos);
};
export const toggleProjects = (pos) => {
  scroll.scrollTo(pos);
};

const Sidebar = () => {
  return (
    <SidebarContainer>
      <ProSidebar collapsed="true" breakPoint="sm" collapsedWidth="120px">
        <Menu iconShape="circle">
          <div
            data-tip="Home"
            data-for="home"
            data-place="right"
            onClick={toggleHome}
          >
            <MenuItem
              className="icon-hover"
              icon={<FaHome size={35} />}
              id="home"
            >
              <Link to="/">Home</Link>
            </MenuItem>
          </div>
          <ReactTooltip
            id="home"
            effect="solid"
            offset={{ left: 30 }}
            backgroundColor="#000000"
            borderColor="#E6DAFF"
            class="mytooltip"
          />

          <div
            data-tip="Skills"
            data-for="skills"
            data-place="right"
            onClick={() => toggleSkills(750)}
          >
            <MenuItem className="icon-hover" icon={<FaCogs size={35} />}>
              <Link to="/">Skills</Link>
            </MenuItem>
          </div>

          <ReactTooltip
            id="skills"
            effect="solid"
            offset={{ left: 30 }}
            backgroundColor="#000000"
            borderColor="#E6DAFF"
            class="mytooltip"
          />
          <div
            data-tip="Projects"
            data-for="projects"
            data-place="right"
            onClick={() => toggleProjects(2550)}
          >
            <MenuItem className="icon-hover" icon={<FaGlobe size={35} />}>
              <Link to="/">Projects</Link>
            </MenuItem>
          </div>
          <ReactTooltip
            id="projects"
            effect="solid"
            offset={{ left: 30 }}
            backgroundColor="#000000"
            borderColor="#E6DAFF"
            className="mytooltip"
          />
          <div
            data-tip="Contact"
            data-for="contact"
            data-place="right"
            onClick={toggleContact}
          >
            <MenuItem className="icon-hover" icon={<FaEnvelope size={35} />}>
              <Link to="/">Contact Me</Link>
            </MenuItem>
          </div>
          <ReactTooltip
            id="contact"
            effect="solid"
            backgroundColor="#000000"
            offset={{ left: 30 }}
            borderColor="#E6DAFF"
            class="mytooltip"
          />
        </Menu>
      </ProSidebar>
    </SidebarContainer>
  );
};

const SidebarContainer = styled.div`
  position: sticky;
  left: 3%;
  top: 30%;
  .mytooltip {
    font-size: 1.2rem;
    font-weight: bolder;
    font-family: "Quicksand", sans-serif;
  }

  .icon-hover {
    &:hover {
      background-color: #23d997;
    }
  }
`;

export default Sidebar;
